import Form from "react-bootstrap/Form";
import "../../../src/main.css";
import React, { useState } from "react";
import { useEffect, useMemo } from "react";
import useAssignedStore from "./assigned_tickets/store";
import moment from "moment";
import Offcanvas from "react-bootstrap/Offcanvas";
import imageCompression from "browser-image-compression";
import { ROLES_NAME, SHOPIFY_CANCEL, TECH_TICKET_ACCESS, customDiscountAccess, filterOption, getCurrentUserRole, getFormattedDate, instantRefundSubcategories, opsTeamMember, partialRefundAccess, refundAccessOps, refundViaApiStatus, requestTypeSubcategories, ticketResolvedAccess } from "modules/utilities/utility";
import { Checkbox, Popconfirm, Upload, Table, Typography, Space, Input, List, Descriptions, Select, Alert, Tooltip, Switch } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { FaMinusCircle } from "react-icons/fa";
import PrescriptionTemplate from "./PrescriptionTemplate";
import { useConsultDoctor, useDoctors, } from "modules/dashboards/actionables/store";
import { useNotificationStore } from "modules/navbar/top/store";
import { useSettingsStore } from "modules/configure_settings/store";
import { toast } from "react-toastify";
import EditTicketInterventionCanvas from "modules/dashboards/feedback_form/EditTicketInterventionCanvas";
import _ from 'lodash';
import EditIcon from "assets/img/illustrations/EditIcon";
import { categories, optionsData } from './data';
import secureLocalStorage from "react-secure-storage";
import { useOrderSearchForTicket } from 'modules/CreateTicket/store';
import useAllTicketStore from "./all_tickets/store";
import { CATEGORY_DOCTOR_FLAG } from "config";
import { groupSlots } from "modules/utilities/utility";
import useStatsStore from "modules/engagement_report/engagement_stats/store";
import { get } from "lodash";
import { Button } from "react-bootstrap";
import DoctorSelection from './DoctorSelection';

const { Text } = Typography;

function UpdateTicket({ customer, ...props }) {
    const { updateAssignedData, updateLoading, getInstantRefund, prescriptionData, updateImageData, postCancelOrder, postEscalationPrescritiption, refundResponse, postOrderCancellationShopify, postShopifyPartialReturnRefund } = useAssignedStore();
    const { bookedData, slotData, allSlotData, bookedLoading, allSlotLoading, fetchOnboardingData, fetchDoctorSlotData, postDoctorSlotData, isLoading, postDoctorSlotMedicalData} = useConsultDoctor();
    const { fetchAvailableDoctorsData, availableDoctorsData } = useDoctors();
    const { allCrmCategories, fetchAllCrmCategories } = useOrderSearchForTicket();
    const { searchResult, fetchCaseData } = useNotificationStore();
    const { pinCode } = useSettingsStore();
    const { rowData, docBookingData } = props;
    const { previousAssignee } = useAssignedStore();
    const userRole = getCurrentUserRole();
    const userId = secureLocalStorage.getItem("id");
    const [submitUpdate, setSubmitUpdate] = useState(0);
    const [comment, setComment] = useState(true);
    const [handleClick, setHandleClick] = useState(false);
    const [ticketAssignee, setTicketAssignee] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [show, setShow] = useState(false);
    const repId = secureLocalStorage.getItem("id");
    const [message, setMessage] = useState("");
    const [checkbox, setCheckBox] = useState(false);
    const [_prescriptionData, set_prescriptionData] = useState([]);
    const [customPres, setCustomPres] = useState(false);
    const [updateRes, setUpdateRes] = useState(false);
    const [doctorsArray, setDoctorsArray] = useState([]);
    const [isFormValid, setIsFormValid] = useState(true);
    const [createPrescription, setCreatePrescription] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [productQuantities, setProductQuantities] = useState({});
    const [searchText, setSearchText] = useState([]);
    const [serviceablePincodes, setServiceablePincodes] = useState("");
    const [totalPrice, setTotalPrice] = useState(0);
    const [disableRefund, setDisableRefund] = useState(false);
    const [currentRefundStatus, setCurrentRefundStatus] = useState("");
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [ticketObject, setTicketObject] = useState(null);
    const [filterSlotData, setFilterSlotData] = useState([]);
    const [doctorMed, setDoctorMed] = useState(null);
    const [selectedSubcat, setSelectedSubcat] = useState(null);
    const [ticketSubCat, setTicketSubCat] = useState(null);
    const [userLevel] = useState(secureLocalStorage.getItem("level"));
    const [statusCode, setStatusCode] = useState("");
    const [medicines, setMedicines] = useState([{ medicine: "", dosage: "", comment: "" }]);
    const [assignee, setAssignee] = useState((rowData?.current_assignment?.first_name));
    const [doctor, setDoctor] = useState(rowData?.current_assignment?.user_id);
    const [alternateAddress, setAlternateAddress] = useState({ locality: "", landmark: "", city: "", state: "", pincode: "", });
    const [updateData, setUpdateData] = useState({ comment: { type: props?.rowData?.category, description: null, commented_by: secureLocalStorage.getItem("id"), }, });
    const [medicalInterventionRequired, setMedicalInterventionRequired] = useState(false);
    const [doctorSubCategoryFlag, setDoctorSubCategoryFlag] = useState(false);
    const { fetchResolvedAssigneeStatus, isResolvedAssignee } = useAllTicketStore();
    const { users, fetchUserData } = useStatsStore();

    useEffect(() => {
        const productQuantity = rowData?.products?.reduce((acc, item) => (acc[item.product_id] = item.quantity, acc), {});
        setProductQuantities(productQuantity);
    }, [rowData]);

    useEffect(()=>{
        if(CATEGORY_DOCTOR_FLAG.includes(_.get(rowData, 'sub_category', null))){
            setDoctorSubCategoryFlag(true);
        } else {
            setDoctorSubCategoryFlag(false);
        }
    },[rowData])
  
    const interventionBookings = docBookingData
    ? docBookingData.filter(booking => 
        ["intervention_call"]?.includes(booking?.booking_type) && !booking?.is_finished && booking?.ticket_id === rowData?._id
      )
    : [];

    const categoriesAssignee = useMemo(() => {
        const categorizedData = allCrmCategories.reduce((acc, category) => {
            const subcategories = category.subcategory.reduce((subAcc, subcategory) => {
                subAcc[subcategory.value] = subcategory.assignees;
                return subAcc;
            }, {});
            acc[category.value] = subcategories;
            return acc;
        }, {});
        return categorizedData
    }, [allCrmCategories])
    
    useEffect(() => { if (availableDoctorsData) { setDoctorsArray(availableDoctorsData); } }, [availableDoctorsData]);
    const doctorsOptions = useMemo(()=>{
        if(availableDoctorsData){
            const doctors = _.get(availableDoctorsData, 'userRole', [])
            .filter((doctor) => _.get(doctor, ['user', 'meta', 'is_intervention_doctor'], false) && _.get(doctor, 'user_id', false) && _.get(doctor,['user', 'first_name'], false))
            .map((doctor)=>({ label: doctor.user.first_name, value: doctor.user.id })).concat(optionsData);
            return doctors;
        }
    }, [availableDoctorsData])
   
    const interventionDocList = useMemo(() => {
        return users
        ?.filter((doctor) => get(doctor, ['user', 'meta', 'is_intervention_doctor'], false) && get(doctor, 'user_id', false) && get(doctor,['user', 'first_name'], false))
        .map((doctor) =>({ label: doctor.user.first_name, value: doctor.user_id }));
      }, [users]);

    useEffect(() => { if (updateRes && prescriptionData?.length > 0) { set_prescriptionData(prescriptionData); } }, [prescriptionData, updateRes]);

    useEffect(() => {
        let assignee = _.get(categoriesAssignee, [rowData.category, rowData.sub_category], []);
        const _ops = [];
        const defaultStakeHolder = assignee.map(subcat => ({ label: subcat.firstName, value: subcat.userId }));
        const transformedPreviousAssignee = previousAssignee?.map((assignee) => ({ label: assignee.firstName || assignee.first_name, value: assignee.userId || assignee.id, })) || [];
        if (rowData?.category !== "medical_escalations") { Object.values(opsTeamMember)?.forEach((item) => _ops.push({ ...item })); }
        const combinedAssignees = [...new Set([...defaultStakeHolder, ...transformedPreviousAssignee, ..._ops,])];
        setTicketAssignee(combinedAssignees);
    }, [previousAssignee, selectedSubcat]);


    useEffect(() => { if (pinCode) { setServiceablePincodes(pinCode); } }, [pinCode]);

    const productsData = useMemo(() => {
        if (searchResult) {
            const foundResult = searchResult.find(result => result?.order_display_id === searchText && result?.case_id === rowData?.case_id);
            if (foundResult) {
                return foundResult?.order_meta?.line_items;
            }
        }
        if (customer) {
            const orderDisplayId = rowData?.source_meta?.order_display_id || rowData?.provider_meta?.subject?.split('|')[0].trim();
            const foundResult = customer.orders.find(result => result.order_display_id === orderDisplayId)
            return foundResult?.order_meta?.line_items
        }
    })

    useEffect(() => {
        setSelectedSubcat(rowData?.category);
        setTicketSubCat(rowData.sub_category);
        setSelectedProducts(rowData?.products);
        setSearchText(rowData?.source_meta?.order_display_id);
        setAlternateAddress(rowData?.address);
        setTotalPrice(Number(rowData?.total_refund_price).toFixed(2));
        setDisableRefund(!(rowData?.refund_status === "Available" || rowData?.refund_status === "Failed"));
        setCurrentRefundStatus(rowData?.refund_status);
        const productQuantity = rowData?.products?.reduce((acc, item) => (acc[item.product_id] = item.quantity, acc), {});
        setProductQuantities(productQuantity);
    }, [rowData]);

    useEffect(() => { setTimeout(() => { setMessage(""); }, [1500]); }, [message]);

    useEffect(() => {
        if (medicalInterventionRequired) {
            let count = _.get(rowData, 'doctor_assignment_count', 0);
            setUpdateData((prevData) => ({ ...prevData, comment: { ...prevData.comment, }, current_assignment: doctorMed, status_code: 3, doctor_assignment_count: count + 1 }));
        } else {
            setUpdateData((prevData) => {
                const { doctor_assignment_count, ...rest } = prevData;
                return rest;
            })
        }
    }, [medicalInterventionRequired, doctorMed]);

    useEffect(() => {
        const update = async () => {
            if (submitUpdate !== 0 && handleClick) {
                const payload = updateData;
                if (medicalInterventionRequired) { payload.slot = selectedSlot }
                await postDoctorSlotData(ticketObject, toast, handleClose, props.rowData._id, payload, updateAssignedData );
                if (ticketObject && selectedSlot && ticketObject) {
                    const handleClose = () => {
                        setSelectedSlot(null);
                        setTicketObject(null);
                        setSelectedDate(null);
                        setFilterSlotData(null);
                        setDoctorMed(null);
                    };
                }
                if (fileList?.length === 0) { props.setRefresh((prev) => !prev); }
                handleClose();
            }
        };
        update();
    }, [submitUpdate]);


    useEffect(() => {
        const temp = async () => {
            if (checkbox) {
                const payload = { doctor: doctor, medicine: medicines, };
                await postEscalationPrescritiption(props.rowData._id, payload);
                setCustomPres(true);
                setUpdateRes(true);
                setCreatePrescription(false);
                setCheckBox(false);
            }
        };
        temp();
    }, [createPrescription]);

    useEffect(() => {
        const isFormValid = () => {
            if (checkbox) {
                if (medicines?.length === 0 || !medicines.every(medicine => medicine.medicine.trim() && medicine.dosage.trim() && medicine.comment.trim())) { return false; }
                if (!doctor) { return false; }
            }
            return true;
        };
        setIsFormValid(isFormValid());
    }, [checkbox, medicines, doctor]);

    useEffect(() => {
        if (typeof refundResponse === "string") {
            toast.error(refundResponse);
            setDisableRefund(true);
        } else if (refundResponse?.status === 200) {
            toast.success("Refund Successfull");
            setCurrentRefundStatus(refundResponse?.data?.refund_status);
            setDisableRefund(true);
        }
    }, [refundResponse]);
    const handleSubmit = (event) => {
        event.preventDefault();
        const doctorData = doctorSubCategoryFlag ? doctor : null;
        fetchOnboardingData({ first_name:rowData.customer.first_name, gender:'M',email:rowData.customer.email, phone_number:rowData.customer.phone_number }, toast);
        if(!doctorSubCategoryFlag){
            fetchDoctorSlotData(rowData.case_id, doctorData, ticketSubCat, toast);
        }
      };


      useEffect(() => {
        if (!_.isEmpty(slotData)) {
          const groupSlot = groupSlots(slotData);
          setFilterSlotData(groupSlot);
        } else {
          setFilterSlotData([]);
        }
      }, [slotData, allSlotData]);

    useEffect(() => { if (checkbox) { fetchAvailableDoctorsData(); } }, [checkbox]);

    useEffect(() => {
        if (selectedProducts && selectedProducts.length !== 0 && Object.keys(productQuantities).length !== 0) {
            calculateTotalPrice(selectedProducts, productQuantities, searchResult[0]?.order_meta);
        }
    }, [selectedProducts, productQuantities, searchResult, productsData]);

    const updates = useMemo(() => {
        if (rowData?.comments && rowData.comments.length > 0) {
            return rowData.comments
                .map(item => `- ${item?.description} (Author: ${item?.action_taker?.first_name}, Time/Date: ${moment(item?.created_at).format("h:mm a, Do MMM YYYY")})`)
                .reverse() // Reverse the array to maintain the correct order
        } else {
            return [];
        }
    }, [rowData?.comments]);

    const calculateTotalPrice = async (selectedProducts, productQuantities, orderMetaData) => {
        let newTotalPrice = 0;
        let totalDiscount = 0;
        const totalAmount = orderMetaData?.total_line_items_price || 0;
        const updatedProducts = selectedProducts.map((product) => {
            const quantity = productQuantities[product.product_id] || 1;

            const originalPrice = parseFloat(product.price) || 0;
            const totalPriceForProduct = originalPrice * quantity;

            let productDiscount = 0;
            const discountCodes = orderMetaData?.discount_applications || [];

            let shippingCharges = orderMetaData?.shipping_lines || [];
            const _totalProductCount = orderMetaData?.line_items?.reduce((total, item) => total + (item?.quantity || 0), 0);

            if (discountCodes.length > 0) {
                const code = discountCodes[0];
                if (code?.value_type === "fixed_amount" && totalAmount > 0) {
                    const percentageValue = (parseFloat(code?.value) / totalAmount) * 100;
                    const percentageOfValueProduct = (percentageValue / 100) * totalPriceForProduct;
                    productDiscount = Math.min(totalPriceForProduct, percentageOfValueProduct);
                } else if (code?.value_type === "percentage") {
                    const percentageValue = parseFloat(code?.value) || 0;
                    const percentageOfValueProduct = (percentageValue / 100) * totalPriceForProduct;
                    productDiscount = Math.min(totalPriceForProduct, percentageOfValueProduct);
                }
            }

            let shippingCost = 0;
            if (shippingCharges.length > 0) {
                const shippingItem = shippingCharges[0] || [];
                const shippingPerProduct = (parseFloat(shippingItem?.price) || 0) / _totalProductCount;
                shippingCost = shippingPerProduct * quantity;
            }

            const refundAmount = Math.max(0, totalPriceForProduct - productDiscount + shippingCost);
            newTotalPrice += refundAmount;
            totalDiscount += productDiscount;
            return { ...product, price: Number(refundAmount.toFixed(2)) };
        });

        const totalRefundAmount = updatedProducts?.reduce((total, product) => total + product.price, 0);

        setTotalPrice(Number(totalRefundAmount).toFixed(2));

        const updatedSelectedProducts = updatedProducts?.map(product => ({ ...product, quantity: productQuantities[product.product_id] || 1 }));

        setUpdateData((prevData) => ({ ...prevData, products: updatedSelectedProducts, total_refund_price: Number(totalRefundAmount).toFixed(2), }));
    };

    const handleFileChange = (info) => { setFileList(info.fileList); };

    const handleCheckboxChange = () => { setMedicalInterventionRequired(!medicalInterventionRequired); };

    const [reason, setReason] = useState("");
    const handleReasonChange = (event) => { setReason(event.target.value); };

    const handleFakeRequest = ({ onSuccess }) => { return setTimeout(() => { onSuccess("ok"); }, 0); };
    const [disableUpdate, setDisableUpdate] = useState(false);

    const isDisabled = () => {
        if (rowData?.status === "Closed") return true;
        if (userRole === "admin" || userRole === "super_admin" || userRole === "doctor_admin" || userRole === "medical") return false;
        if (userRole === "medical_rep" && userLevel == "3") return false;
        if (rowData?.current_assignment?.user_id === repId) return false;
        if (TECH_TICKET_ACCESS) return false;
        return true;
    };

    const handleCreatePrescription = () => { setCreatePrescription(true); };

    const addMedicine = () => { setMedicines([...medicines, { medicine: "", dosage: "", comment: "" }]); };

    const deleteMedicine = index => { setMedicines(prevMedicines => prevMedicines.filter((_, i) => i !== index)); };


    const handleChange = (event, index) => {
        const { name, value } = event.target;
        if (name == "description") {
            if (value.length !== 0) {
                setComment(false);
                setHandleClick(true);
            } else {
                setComment(true);
                setHandleClick(false);
            }
            setUpdateData({ ...updateData, comment: { ...updateData.comment, [name]: value, }, action_taker: secureLocalStorage.getItem("id"), });
        }
        else if (name === "doctor") { setDoctor(value); }
        else if (name === "checkboxPrescription") { setCheckBox(event.target.checked); }
        else if (name === "dosage") {
            const dosagePattern = /^[\d-]*$/;
            const isValidDosage = dosagePattern.test(value);
            setIsFormValid(isValidDosage);

            if (isValidDosage) {
                const newMedicines = [...medicines];
                newMedicines[index][name] = value;
                setMedicines(newMedicines);
            }
        }
        else if (name === "medicine" || name === "comment") {
            const newMedicines = [...medicines];
            newMedicines[index][name] = value;
            setMedicines(newMedicines);
        } else if (name.startsWith("alternateAddress-")) {
            const alternateFieldName = name.replace("alternateAddress-", "");
            if (alternateFieldName === "pincode") {
                const isPincodeTrue = serviceablePincodes.includes(value);
                if (!isPincodeTrue) {
                    setDisableUpdate(true);
                } else {
                    setDisableUpdate(false);
                }
            }
            const updatedAlternateAddress = { ...alternateAddress, [alternateFieldName]: value };

            setUpdateData({ ...updateData, address: updatedAlternateAddress });

            setAlternateAddress(updatedAlternateAddress);
        } else {
            setUpdateData({ ...updateData, [name]: value, action_taker: secureLocalStorage.getItem("id") });
            if (!checkbox) { setIsFormValid(true); }
        }
    };

    const handleUpdate = () => {
        if (!updateData?.comment?.description) { return; }
        uploadFile(fileList);
        setSubmitUpdate(submitUpdate + 1);
    };

    const handleClose = () => {
        setShow(false);
        setFileList([]);
        setCheckBox(false);
        setDoctor("");
        // setRenderFlag();
        set_prescriptionData([]);
        setUpdateRes(false);
        setDisableRefund(false);
        useAssignedStore.setState({ refundResponse: null });
    };

    const uploadFile = async (fileList) => {
        const options = { maxSizeMB: 5, useWebWorker: true };

        const imageDataArray = [];

        for (let image = 0; image < fileList?.length; image++) {
            const file = fileList[image];
            const type = fileList[image]?.type;
            let fileData = new FormData();
            let compressedFile = null;
            if (type !== "application/pdf") {
                compressedFile = await imageCompression(file.originFileObj, options);
            } else {
                compressedFile = file.originFileObj;
            }
            fileData.append("file", compressedFile, file.name);
            imageDataArray.push(fileData);
        }

        const uploadImage = imageDataArray?.map(async (item) => updateImageData(item, rowData?._id));
        await Promise.all(uploadImage);
        if (fileList?.length !== 0) { props.setRefresh(!props.refresh); }
    };

    const handleCancel = (orderId) => { postCancelOrder({ order_display_id: orderId, }, setMessage); };

    const handleOrderCancelDirect = (orderId) => { postOrderCancellationShopify({ order_display_id: orderId, }, toast); };

    const handleInstantRefund = async (orderDisplayId, totalPrice, ticketId) => {
        setDisableRefund(true);
        await getInstantRefund(orderDisplayId, totalPrice, ticketId, userId);
    };

    const getProductQuantity = (productId) => {
        const product = productsData?.find(product => product.product_id == productId);
        return product ? product.quantity : 0;
    }

    const columns = [
        { title: 'Product Name', dataIndex: 'name', key: 'name' },
        { title: 'Quantity', dataIndex: 'quantity', key: 'quantity' },
        { title: 'Refunded', dataIndex: 'refunded', key: 'refunded' },
        { title: 'Refund Req.', dataIndex: 'requestedRefund', key: 'requestedRefund' },
    ];

    return rowData === undefined ? ("") : (
        <div style={{ zIndex: "9" }} key={props.id}>
            {_prescriptionData?.length > 0 && customPres && updateRes && (
                <PrescriptionTemplate
                    data={_prescriptionData}
                    handleClose={handleClose}
                    ticket={rowData}
                    setCustomPres={setCustomPres}
                    ticketData={updateData}
                    setUpdateData={setUpdateData}
                />
            )}
            <Tooltip title='Edit Ticket'>
                <div variant="primary" 
                    onClick={() => {
                        fetchCaseData(searchText);
                        _.isEmpty(isResolvedAssignee) && fetchResolvedAssigneeStatus();      
                        setShow(true);
                        _.isEmpty(allCrmCategories) && fetchAllCrmCategories();
                        _.isEmpty(isResolvedAssignee) && fetchResolvedAssigneeStatus();    
                        !_.isEmpty(searchText) && fetchCaseData(searchText);
                        setShow(true);
                    }}
                    className="me-2">
                        <EditIcon />
                </div>
            </Tooltip>
            <Offcanvas show={show} style={{ width: "40vw" }} onHide={handleClose} placement='end'>
                <Offcanvas.Header className='w-100 d-flex justify-content-center mt-2'>
                    <Offcanvas.Title className='d-flex justify-content-between align-items-center w-100 p-0 m-0' >
                        <h5>Update Ticket #{rowData?.ticketNumber} </h5>
                        {isDisabled() && <Alert message="Ticket can only be edited by Ticket Assignee and TL. You canstill add comments" type="error" showIcon />}
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className='overflow-hidden'>
                    <div className='h-100'>
                        <div className="d-flex flex-column gap-3 scrollable-container" style={{ height: '94%', overflowY: 'scroll' }}>
                            {rowData?.source_meta?.order_details && rowData?.source_meta?.order_details.length > 0 &&
                                <Descriptions bordered layout="vertical" title="Order Details" className='border border-1 p-2 rounded'>{
                                    rowData?.source_meta?.order_details.split('\n').filter(Boolean).map((detail) => {
                                        const [label, ...value] = detail.split(':');
                                        return <Descriptions.Item label={label}>{value.join(':')}</Descriptions.Item>
                                    })
                                }
                                    <Descriptions.Item label='Category'>{categories[rowData?.category]} </Descriptions.Item>
                                    <Descriptions.Item label='Subcategory'>{categories[rowData?.sub_category]} </Descriptions.Item>
                                </Descriptions>
                            }
                            {rowData?.remark &&
                                <Space.Compact block className='mt-3 mb-1'>
                                    <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                                        className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                                        <Text color='green'>Remarks</Text>
                                    </span>
                                    <Input style={{ width: '70%' }} value={rowData.remark} />
                                </Space.Compact>
                            }

                            {rowData?.products && rowData?.products.length > 0 && (
                                <Form.Group >
                                    <Table
                                        dataSource={rowData?.products.map(product => ({
                                            name: product?.name,
                                            quantity: getProductQuantity(product?.product_id),
                                            refunded: product?.refundQuantity || 0,
                                            requestedRefund: productQuantities[product?.product_id],
                                        }))}
                                        columns={columns}
                                        pagination={false}
                                    />
                                </Form.Group>
                            )}

                            {instantRefundSubcategories.includes(rowData?.sub_category) ? <>
                                {totalPrice && totalPrice > 0 &&
                                    <Space.Compact block className='mb-1'>
                                        <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                                            className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                                            <Text color='green'>Total Price</Text>
                                        </span>
                                        <Input style={{ width: '70%' }} value={`RS ${Number(totalPrice).toFixed(2)}`} />
                                    </Space.Compact>
                                }
                                {currentRefundStatus && (
                                    <Space.Compact block className='mb-1'>
                                        <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                                            className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                                            <Text>Refund Status</Text>
                                        </span>
                                        <Input style={{ width: '70%' }} value={currentRefundStatus} />
                                    </Space.Compact>
                                )}
                                {rowData?.sub_category && requestTypeSubcategories.includes(rowData?.sub_category) && (
                                    <Space.Compact block className='mb-1'>
                                        <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                                            className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                                            <Text>Request Type</Text>
                                        </span>
                                        <Input style={{ width: '70%' }} value={rowData?.request_type} />
                                    </Space.Compact>
                                )}
                            </> : <div className='mt-1'></div>}

                            <Space.Compact block className='mb-1'>
                                <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                                    className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                                    <Text>TAT</Text>
                                </span>
                                <Input style={{ width: '70%' }} value={getFormattedDate(rowData?.due_date, "YYYY/MM/DD HH:mm:ss")} />
                            </Space.Compact>
                            {[ROLES_NAME.ADMIN].includes(getCurrentUserRole()) && interventionBookings?.length > 0 &&
                                        ["medical_escalations", "customer_complaints"].includes(rowData?.category) &&
                                        rowData?.status === "Pending" ? (
                                        <DoctorSelection 
                                        userRole={userRole}
                                        rowData={rowData}
                                        interventionDocList={interventionDocList}
                                        booked Loading={bookedLoading}
                                        allSlotLoading={allSlotLoading}
                                        filterSlotData={filterSlotData}
                                        setTicketObject={setTicketObject}
                                        updateData={updateData}
                                        setUpdateData={setUpdateData}
                                        docBookingData= {docBookingData}
                                        ticketId ={rowData?._id}
                                    />
                                    ) : (
                            <Space.Compact block className='mb-3'>
                                    <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                                    className='border border-1 border-end-0 d-flex justify-content-center align-items-center rounded-lg rounded-start px-2'>
                                        <Text>Select Assignee</Text>
                                    </span>    
                                        <Select
                                            style={{ width: '70%' }}
                                            showSearch
                                            placeholder='Select a subcategory'
                                            optionFilterProp='children'
                                            value={assignee}
                                            onChange={(value) => {
                                                setAssignee(value);
                                                setUpdateData({ ...updateData, current_assignment: value });
                                            }}
                                            filterOption={filterOption}
                                            options={ticketAssignee?.map((item, index) => ({ value: item?.value, label: item?.label, key: index}))}
                                            disabled={isDisabled()}
                                        />
                                    
                            </Space.Compact>
                                    )}

                            {updateData.current_assignment && rowData?.category === 'medical_escalations' && <div className='d-flex justify-content-between align-items-center p-2 border rounded'>
                                <Text>Medical Agent Reassignement  </Text>
                                <Switch onChange={(value) => {
                                    if (value) {
                                        setUpdateData({ ...updateData, medical_agent: updateData.current_assignment });
                                    } else {
                                        setUpdateData((prevData) => {
                                            const { medical_agent, ...rest } = prevData;
                                            return rest;
                                        })
                                    }
                                }} />
                            </div>}
                            <List
                                size="small"
                                header={<div>Updates</div>}
                                bordered
                                dataSource={updates}
                                renderItem={(item) => <List.Item>{item}</List.Item>}
                            />
                            { rowData?.category?.toLowerCase() !== "medical_escalations" ? <Form.Group className="mb-1" style={{ marginTop: "8px" }}>
                                <Form.Check
                                    type="checkbox"
                                    id="medicalInterventionCheckbox"
                                    label="Medical Intervention Required"
                                    checked={medicalInterventionRequired}
                                    onChange={(e) => {
                                        handleCheckboxChange(e);
                                        handleSubmit(e); 
                                      }}

                                />
                            </Form.Group> : null}

                            {medicalInterventionRequired && (
                                <>
                                    <Form.Group
                                        className="mb-3"
                                        controlId="exampleForm.ControlTextarea1"
                                    >
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            placeholder="Reason for Doctor Intervention"
                                            onChange={handleReasonChange}
                                            defaultValue={reason}
                                        />
                                    </Form.Group>
                                    <EditTicketInterventionCanvas
                                        caseId={rowData?.case_id}
                                        name={rowData?.customer.first_name}
                                        email={rowData?.customer.email}
                                        phone={rowData?.customer.phone_number}
                                        tickeId={rowData._id}
                                        reason={reason}
                                        selectedSlot={selectedSlot}
                                        setSelectedSlot={setSelectedSlot}
                                        selectedDate={selectedDate}
                                        setSelectedDate={setSelectedDate}
                                        setTicketObject={setTicketObject}
                                        filterSlotData={filterSlotData}
                                        setFilterSlotData={setFilterSlotData}
                                        doctorMed={doctorMed}
                                        setDoctorMed={setDoctorMed}
                                        doctorSubCategoryFlag = {doctorSubCategoryFlag}
                                    />
                                </>
                            )}

                            <Space.Compact block className='mb-3'>
                                <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                                    className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                                    <Text>Status</Text>
                                </span>
                                <Select
                                    style={{ width: '70%' }}
                                    showSearch
                                    placeholder='Select a Status'
                                    optionFilterProp='children'
                                    defaultValue={rowData?.status}
                                    onChange={(value) => {
                                        setStatusCode(value);
                                        setUpdateData((prevData) => {
                                            if (value !== '5') {
                                                const { callType, ...rest } = prevData;
                                                return { ...rest, status_code: value };
                                            } else {
                                                return { ...prevData, status_code: value };
                                            }
                                        });
                                    }}
                                    filterOption={filterOption}
                                    options={
                                        isResolvedAssignee ?
                                            [{ value: "2", label: "Open" }, { value: "3", label: "Pending" }, { value: "4", label: "Resolved" }, { value: "5", label: "Closed" }] :
                                            [{ value: "2", label: "Open" }, { value: "3", label: "Pending" }, { value: "5", label: "Closed" }]
                                    }
                                    disabled={isDisabled() || medicalInterventionRequired}
                                />
                            </Space.Compact>

                            {statusCode === '5' && <Space.Compact block className='mb-3'>
                                <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                                    className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                                    <Text>Call Type</Text>
                                </span>
                                <Select
                                    style={{ width: '70%' }}
                                    placeholder='Select Call type'
                                    optionFilterProp='children'
                                    onChange={(value) => {
                                        setUpdateData({ ...updateData, callType: value });
                                    }}
                                    filterOption={filterOption}
                                    options={[{ value: "answered", label: "Answered" }, { value: "unanswered", label: "Unanswered" }]}
                                />
                            </Space.Compact>}

                            <div className="form-floating d-flex flex-column gap-1">
                                <div><span className="red-star text-danger">*</span> Comment</div>
                                <textarea
                                    required
                                    name="description"
                                    id="floatingTextarea2"
                                    style={{ height: "60px" }}
                                    placeholder="Leave a comment here"
                                    onChange={handleChange}
                                    disabled={rowData?.status === "Closed"}
                                    className={rowData?.status === "Closed" ? "form-control opacity-50 disabled-select" : "form-control"}
                                ></textarea>
                                {comment ? (<p className="text-danger">Comment is required</p>) : (<p>{" ."}</p>)}
                            </div>

                            {rowData.category === "medical_escalations" && statusCode === "5" && (
                                <>
                                    <div>
                                        <Tooltip
                                            title={
                                                [ROLES_NAME?.MEDICAL_REP, ROLES_NAME?.MEDICAL]?.includes(getCurrentUserRole())
                                                    ? "You do not have permission to send prescriptions. Please contact an authorized doctor."
                                                    : ""
                                            }
                                        >
                                            <Checkbox name="checkboxPrescription" onChange={handleChange} disabled={[ROLES_NAME?.MEDICAL_REP, ROLES_NAME?.MEDICAL]?.includes(getCurrentUserRole())}
                                            >
                                                Add Prescription
                                            </Checkbox>
                                        </Tooltip>
                                    </div>
                                    {checkbox && statusCode === "5" && (
                                        <>
                                            <div className="form-floating d-flex flex-column gap-1">
                                                {medicines.map((medicine, index) => (
                                                    <div
                                                        key={index}
                                                        className="d-flex justify-content-between"
                                                    >
                                                        <div style={{ width: "35%" }}>
                                                            <input
                                                                type="text"
                                                                name="medicine"
                                                                className="form-control"
                                                                placeholder="Medicine Name"
                                                                value={medicine.medicine}
                                                                onChange={(event) => handleChange(event, index)}
                                                                required
                                                            />
                                                        </div>
                                                        <div style={{ width: "15%", marginLeft: "10px" }}>
                                                            <input
                                                                type="text"
                                                                name="dosage"
                                                                className="form-control"
                                                                placeholder="Dosage"
                                                                value={medicine.dosage}
                                                                onChange={(event) => handleChange(event, index)}
                                                                required
                                                            />
                                                        </div>
                                                        <div style={{ width: "35%" }}>
                                                            <input
                                                                type="text"
                                                                name="comment"
                                                                className="form-control"
                                                                placeholder="Prescription Comment"
                                                                value={medicine.comment}
                                                                onChange={(event) => handleChange(event, index)}
                                                                required
                                                            />
                                                        </div>
                                                        <button className="btn btn-danger" onClick={() => deleteMedicine(index)}>
                                                            <FaMinusCircle />
                                                        </button>
                                                    </div>
                                                ))}
                                                <button
                                                    className="btn btn-primary mt-2"
                                                    onClick={addMedicine}
                                                >
                                                    Add Medicine
                                                </button>
                                            </div>
                                            <div className="d-flex flex-column gap-1">
                                                <div>
                                                    <span className="red-star text-danger">*</span> Doctor
                                                </div>
                                                <select
                                                    required
                                                    name="doctor"
                                                    value={doctor}
                                                    disabled={isDisabled()}
                                                    aria-label="Default select example"
                                                    onChange={(event) => handleChange(event)}
                                                    className={rowData?.status === "Closed" || isDisabled() ? "form-select opacity-50 disabled-select" : "form-select"}
                                                >
                                                    <option value="" className="d-none">Select a doctor</option>
                                                    {doctorsOptions.map((doctor) => <option key={doctor.value} value={doctor.value}>{doctor.label}</option>)}
                                                </select>
                                            </div>
                                        </>
                                    )}
                                </>
                            )}

                            <Form className="mt-0">
                                <Form.Group controlId="imageUpload ">
                                    <Form.Label>Upload Images</Form.Label>
                                    <Upload
                                        accept="image/png, image/jpeg, application/pdf"
                                        listType="picture-card"
                                        customRequest={handleFakeRequest}
                                        onChange={handleFileChange}
                                        onPreview={(file) => { if (typeof window.URL.createObjectURL === "function") { window.open(window.URL.createObjectURL(file.originFileObj), "_blank").focus(); } }}
                                    >
                                        <div className="flex flex-col gap-2"><PlusOutlined /><span>Upload</span></div>
                                    </Upload>
                                </Form.Group>
                            </Form>

                        </div>

                        <div className="d-flex justify-content-between align-items-center mb-4 bottom-0 py-3">
                            <Button
                                type="primary"
                                onClick={handleUpdate}
                                className='w-50'
                                disabled={rowData?.status === "Closed" || (statusCode === '5' && !updateData.callType)  || !isFormValid || comment || createPrescription || checkbox || disableUpdate}
                                loading={updateLoading}
                            >
                                Update
                            </Button>
                            {(rowData.trackingStatus && refundViaApiStatus.includes(rowData.trackingStatus)) && partialRefundAccess.includes(secureLocalStorage.getItem("email")) &&
                                <Button type="primary" danger
                                    disabled={rowData?.status === "Closed" || !isFormValid || comment}
                                    onClick={() => {
                                        postShopifyPartialReturnRefund(
                                            {
                                                order_display_id: rowData.source_meta.order_display_id,
                                                to_refund_product_details: rowData.products.map(product => ({ product_id: product.product_id, quantity: parseInt(product.quantity) })),
                                                refund_value: parseFloat(Number(totalPrice).toFixed(2))
                                            }
                                        )
                                    }}
                                >
                                    Partial Refund
                                </Button>
                            }

                            {rowData?.sub_category === "initiate_rto" && customDiscountAccess.includes(secureLocalStorage.getItem("email")) &&
                                <Button type="primary" danger
                                    disabled={rowData?.status === "Closed" || !isFormValid || comment}
                                    onClick={() => handleCancel(rowData?.source_meta?.order_display_id)}
                                >
                                    Refund Via Api
                                </Button>
                            }

                            {rowData?.sub_category === "order_cancellation" && SHOPIFY_CANCEL.includes(secureLocalStorage.getItem("email")) &&
                                <Popconfirm
                                    title="Are you sure to Cancel Order in SHopify?"
                                    description={
                                        <div>
                                            <div className="text-primary">This action cannot be undone.</div>
                                            <div className="text-primary">This will directly cancel order in Shopify.</div>
                                            <div className="text-danger fw-bold">Following actions need to be performed before this.</div>
                                            <div className="text-danger">1. Cancel order in delivery partner (ITL/ Proship /Blitz)</div>
                                            <div className="text-danger">2. Cancel order in Prozo.</div>
                                            <div className="text-danger">3. Cancel order in UC</div>
                                        </div>
                                    }
                                    onConfirm={() => handleOrderCancelDirect(rowData?.source_meta?.order_display_id)}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button danger className="mx-2">Order Cancel. Shopify</Button>
                                </Popconfirm>
                            }

                            {rowData?.category === "medical_escalations" && checkbox && (
                                <button className="btn btn-danger ms-4" onClick={() => { handleCreatePrescription(); }}>
                                    Create Prescription
                                </button>
                            )}
                            {refundAccessOps.includes(secureLocalStorage.getItem("email")) &&
                                <div className="d-flex flex-column">
                                    <Button type="primary" danger
                                        disabled={rowData?.status === "Closed" || !isFormValid || comment || disableRefund}
                                        onClick={() => { handleInstantRefund(searchText, totalPrice, rowData?._id); }}
                                    >
                                        Instant Refund
                                    </Button>
                                </div>
                            }
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </div>
    );
}

export default UpdateTicket;
